import _extends from "@babel/runtime/helpers/extends";
import Textfield from '@atlaskit/textfield';
import { NumberUtils } from '@atlassian/mpac-utils';
import React from 'react';

const NumericTextField = props => {
  const {
    min = Number.NEGATIVE_INFINITY,
    max = Number.POSITIVE_INFINITY
  } = props;
  const {
    isRounded,
    ...passThroughProps
  } = props;

  const handleChange = e => {
    var _props$onChange;

    const {
      value
    } = e.target;
    const numberVal = Number(value);
    const roundedVal = isRounded ? Math.round(numberVal) : numberVal;
    const clampedVal = NumberUtils.bindNumberInRange(roundedVal, min, max);
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, clampedVal);
  };

  return /*#__PURE__*/React.createElement(Textfield, _extends({
    type: "number"
  }, passThroughProps, {
    onChange: handleChange
  }));
};

export default NumericTextField;